import React from 'react'
import { Box } from '@chatterbug/aaron'

const SEPARATOR_STYLES = {
  textAlign: { _: 'left', tablet: 'right' },
  color: 'blue42',
  borderRightStyle: 'solid',
  borderRightWidth: '1px',
  marginRight: '1x',
  paddingRight: '1x',
  height: '14px',
}

const Separator = () => {
  return <Box as="span" sx={SEPARATOR_STYLES}></Box>
}

export default Separator
